import { render } from "./TextareaField.vue?vue&type=template&id=4f24fa4c&scoped=true"
import script from "./TextareaField.vue?vue&type=script&lang=js"
export * from "./TextareaField.vue?vue&type=script&lang=js"

import "./TextareaField.vue?vue&type=style&index=0&id=4f24fa4c&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f24fa4c"]])

export default __exports__